import { reactQueryDelete } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

interface RemoveMemberFromSpaceGroupParams {
  memberId: string | number;
  spaceGroupId: number;
}

export const useRemoveMemberFromSpaceGroup = (
  options?: UseMutationOptions<
    unknown,
    Error,
    RemoveMemberFromSpaceGroupParams
  >,
) => {
  const mutation = ({
    spaceGroupId,
    memberId,
  }: RemoveMemberFromSpaceGroupParams) =>
    reactQueryDelete(
      internalApi.spaceGroups.deleteMember({
        spaceGroupId,
        memberId,
      }),
    );

  return useMutation({ ...options, mutationFn: mutation });
};
